import './App.css';
import ReportContainer from './Containers/ReportContainer'

function App() {
  return (
    <ReportContainer/>
    );
}

export default App;
